module.exports = __webpack_public_path__ + "static/PFB__0004_Midterm-c72f27238c16123d7b3a1076463da1d8.png";